"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicComponent = void 0;
const react_1 = __importDefault(require("react"));
const BasicComponent = ({ children }) => {
    return react_1.default.createElement("div", null, children);
};
exports.BasicComponent = BasicComponent;
//# sourceMappingURL=index.js.map